import {
  AnalyticsTrackingConfig,
  normalizeAnalyticsPagePath,
  ResolvedAnalyticsPage,
} from '@imagise/features/analytics-consent';
import { AnalyticsService, LocalizationService } from '@imagise/shared';
import { TOOL_PAGES } from '../pages/tool-pages.config';

const ANALYTICS_TOOL_SLUGS = TOOL_PAGES.map(tool => tool.slug);

function contentLanguage(page: ResolvedAnalyticsPage, localization: LocalizationService): string {
  const routeLanguage = page.path.split('/')[1];
  return localization.getSupportedLanguages().includes(routeLanguage)
    ? routeLanguage
    : localization.currentLang();
}

export const IMAGISE_APP_ANALYTICS_TRACKING_CONFIG: AnalyticsTrackingConfig = {
  resolvePage(url: string): ResolvedAnalyticsPage {
    const path = normalizeAnalyticsPagePath(url);
    return { key: path, path };
  },
  buildAllowlist(localization: LocalizationService) {
    return {
      toolSlugs: ANALYTICS_TOOL_SLUGS,
      contentLanguages: localization.getSupportedLanguages(),
    };
  },
  contentLanguage,
  trackPageExtras(analytics: AnalyticsService, page: ResolvedAnalyticsPage, localization: LocalizationService) {
    const language = contentLanguage(page, localization);
    const toolSlug = ANALYTICS_TOOL_SLUGS.find(
      slug => page.path === `/${slug}` || page.path === `/${language}/${slug}`
    );
    if (toolSlug) {
      analytics.track('tool_open', { tool_slug: toolSlug });
    }
  },
};
